var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppSidebar',{attrs:{"fixed":true}},[_c('SidebarHeader'),_c('SidebarForm'),_c('SidebarNav',{attrs:{"navItems":_vm.transladedNav,"fixed":""}}),_c('SidebarFooter'),_c('SidebarMinimizer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }